import { ExpensePolicyBy } from "./ExpensePolicy.type";

export enum SettingParameterTypeValue {
  INTEGER = "integer",
  BOOLEAN = "boolean",
  FLOAT = "float",
  PERCENTAGE = "percentage",
  SELECT = "select",
}

export enum SettingParameterType {
  CUSTOMER = "customer",
  AGENCY = "agency",
  BOTH = "both",
}

export enum SettingParameterSlug {
  HOTEL_PRICE_CHANGE = "hotel-price-change-parameter",
  VOUCHER_WITHOUT_VALUE = "voucher-without-value",
  SELECT_APPROVERS = "select-approvers",
  POLICY_BY_REASON_TRIP = "policy-by-reason-trip",
  MANAGE_BUDGET_BY = "manage-budget-by",
  COST_CENTER_REQUIRED_PHASE = "cost-center-required-phase",
  APPROVAL_BY = "approval-by",
  DEFAULT_CUSTOMER_EMPLOYEE_GROUP = "default-customer-employee-group",
  MIN_CHARS_CANCEL_ORDER_OBS = "min-chars-cancel-order-obs",
  REQUIRE_BRANCH_ON_APPROVAL_REQUEST = "require-branch-on-approval-request",
  REQUIRE_APPROVER_ON_APPROVAL_REQUEST = "require-approver-on-approval-request",
  SHOW_EXTERNAL_ORDER_FIELD = "show-external-order-field",
  MIN_CHARS_POLICY_JUSTIFY_VIOLATION = "min-chars-policy-justify-violation",
  EDIT_EXPENSE_FIELDS_AFTER_OCR_READ = "edit-expense-fields-after-ocr-read",
  EXPENSE_POLICY_BY = "expense-policy-by",
  REQUIRE_PROJECT_ON_APPROVAL_REQUEST = "require-project-on-approval-request",
  REQUIRE_POLICY_VIOLATION_JUSTIFICATION = "require-policy-violation-justification",
  VALUE_PER_KILOMETER = "value-per-kilometer",
  ODOMETER_IMAGE_REQUIRED = "odometer-image-required",
  REQUIRED_KM_DRIVEN = "required-km-driven",
  CUSTOMER_CARD_STATUS = "customer-card-status",
  LODGING_FIXED_DAILY_ENABLED = "lodging-fixed-daily-enabled",
  ENABLE_POLICY_VIOLATION_ATTACHMENT_UPLOAD = "enable-policy-violation-attachment-upload",
  REQUIRE_PIX_FOR_ADVANCES = "require-pix-for-advances",
  AIRWAY_CALENDAR_PICKER_ENABLED = "airway-calendar-picker-enabled",
  RESTRICT_EMPLOYEE_COST_CENTERS = "restrict-employee-cost-centers",
  MAX_AIRWAY_PASSENGERS = "max-airway-passengers",
}

export enum BudgetOption {
  COST_CENTER = "cost_center",
  PROJECT = "project",
  PHASE = "phase",
  GROUP = "customer_employee_group",
}

export enum CustomerCardStatus {
  NOT_AVAILABLE = "NOT_AVAILABLE",
  REQUESTED = "REQUESTED",
  ACTIVE = "ACTIVE",
}

export enum ApprovalOption {
  COST_CENTER = "cost_center",
  PROJECT = "project",
  PHASE = "phase",
  GROUP = "customer_employee_group",
}

export type SettingParameter = {
  uuid: string;
  slug: SettingParameterSlug;
  description: string;
  type: SettingParameterType;
  typeValue: SettingParameterTypeValue;
  value: string;
};

export const getAvailableParameterOptions = (slug: string) => {
  switch (slug) {
    case SettingParameterSlug.MANAGE_BUDGET_BY:
      return [
        { label: "Centro de custo", value: BudgetOption.COST_CENTER },
        { label: "Projeto", value: BudgetOption.PROJECT },
        { label: "Fase", value: BudgetOption.PHASE },
        { label: "Não definido", value: "" },
      ];
    case SettingParameterSlug.APPROVAL_BY:
      return [
        { label: "Centro de custo", value: ApprovalOption.COST_CENTER },
        { label: "Projeto", value: ApprovalOption.PROJECT },
        { label: "Fase", value: ApprovalOption.PHASE },
        { label: "Grupo", value: ApprovalOption.GROUP },
        { label: "Não definido", value: "" },
      ];
    case SettingParameterSlug.CUSTOMER_CARD_STATUS:
      return [
        { label: "Não disponível", value: CustomerCardStatus.NOT_AVAILABLE },
        { label: "Requisitado", value: CustomerCardStatus.REQUESTED },
        { label: "Ativo", value: CustomerCardStatus.ACTIVE },
      ];
    case SettingParameterSlug.EXPENSE_POLICY_BY:
      return [
        { label: "Grupo", value: ExpensePolicyBy.GROUP },
        { label: "Não definido", value: ExpensePolicyBy.NONE },
      ];
    default:
      return undefined;
  }
};

export const getDefaultLabelParameterSelect = (data: string) => {
  switch (data) {
    case ApprovalOption.COST_CENTER: {
      return "Centro de custo";
    }
    case ApprovalOption.GROUP: {
      return "Grupo";
    }
    case ApprovalOption.PHASE: {
      return "Fase";
    }
    case ApprovalOption.PROJECT: {
      return "Projeto";
    }
    case CustomerCardStatus.NOT_AVAILABLE: {
      return "Não disponível";
    }
    case CustomerCardStatus.REQUESTED: {
      return "Requisitado";
    }
    case CustomerCardStatus.ACTIVE: {
      return "Ativo";
    }
    case ExpensePolicyBy.NONE: {
      return "Não definido";
    }
    default:
      return "Não definido";
  }
};

export const getDefaultLabelParameterCardStatus = (data: string) => {
  switch (data) {
    case CustomerCardStatus.NOT_AVAILABLE: {
      return "Não disponível";
    }
    case CustomerCardStatus.REQUESTED: {
      return "Requisitado";
    }
    case CustomerCardStatus.ACTIVE: {
      return "Ativo";
    }
    default:
      return "Não definido";
  }
};
